import { lazy } from "react";

const PreferencesPopup = lazy(() => import("@/components/popups/PreferencesPopup"));
const ChangedEmailPopup = lazy(() => import("@/components/popups/ChangedEmailPopup"));
const AddToNichePopup = lazy(() => import("@/components/popups/AddToNichePopup"));
const ReportPopup = lazy(() => import("@/components/popups/Report"));
const AddToCollectionPopup = lazy(() => import("@/components/popups/AddToCollectionPopup"));
const CreateNewCollectionPopup = lazy(() => import("@/components/popups/CreateNewCollectionPopup"));
const EditNichePopup = lazy(() => import("@/components/popups/EditNichePopup"));
const EditNichesDialog = lazy(() => import("@/components/popups/EditNichesDialog"));
const GifPreferencePopup = lazy(() => import("@/components/popups/GifPreferencePopup"));
const ShareGifMenu = lazy(() => import("@/components/popups/ShareMenu"));
const MoreMenu = lazy(() => import("@/components/popups/MoreMenu"));
const NicheMoreMenu = lazy(() => import("@/components/popups/NicheMoreMenu"));
const EditGifPopup = lazy(() => import("@/components/popups/EditGifPopup"));
const AddToNicheSuccessPopup = lazy(() => import("@/components/popups/AddToNicheSuccessPopup"));
const AddDescriptionPopup = lazy(() => import("@/components/popups/AddDescriptionPopup"));
const GifNichesPopup = lazy(() => import("@/components/popups/GifNichesPopup"));
const ProfileOptions = lazy(() => import("@/components/popups/ProfileOptions"));
const DeleteAccount = lazy(() => import("@/components/popups/DeleteAccount"));
const AddToNicheConfirm = lazy(() => import("@/components/popups/AddToNicheConfirm"));
const CreateNichePopup = lazy(() => import("@/components/popups/CreateNichePopup"));
const CaptchaPopup = lazy(() => import("@/components/popups/CaptchaPopup"));
const AgeDisclaimerPopup = lazy(() => import("@/components/popups/AgeDisclaimerPopup"));
const AgeVerificationPromptPopup = lazy(() => import("@/components/popups/AgeVerificationPromptPopup"));
const AgeVerificationConnectingPopup = lazy(() => import("@/components/popups/AgeVerificationConnectingPopup"));
const AgeVerificationCompletePopup = lazy(() => import("@/components/popups/AgeVerificationCompletePopup"));
const AgeVerificationNotCompletedPopup = lazy(() => import("@/components/popups/AgeVerificationNotCompletedPopup"));
const SFWPopup = lazy(() => import("@/components/popups/SFWPopup"));
const LiteDelayedAVPopup = lazy(() => import("@/components/popups/LiteDelayedAVPopup"));
const LiteOnlyVerificationPopup = lazy(() => import("@/components/popups/LiteOnlyVerificationPopup"));

export enum PopupsEnum {
  Preferences = "preferences",
  ChangedEmail = "changedEmail",
  AddNiche = "addNiche",
  Report = "report",
  AddCollection = "addCollection",
  CreateCollection = "createCollection",
  EditNiche = "editNiche",
  EditGifNiches = "editGifNiches",
  EditGifPreferences = "editGifPreferences",
  ShareGif = "shareGif",
  MoreMenu = "moreMenu",
  EditGif = "editGif",
  NicheMoreMenu = "nicheMoreMenu",
  AddToNicheSuccess = "addToNicheSuccess",
  AddDescriptionPopup = "addDescriptionPopup",
  AddToNicheConfirm = "addToNicheConfirm",
  CreateNiche = "createNiche",
  CaptchaPopup = "captchaPopup",
  Verification = "verification",
  GifNiches = "gifNiches",
  ProfileOptions = "profileOptions",
  DeleteAccount = "deleteAccount",
  AgeDisclaimer = "ageDisclaimer",
  AgeVerificationPrompt = "ageVerificationPrompt",
  AgeVerificationConnecting = "ageVerificationConnecting",
  AgeVerificationComplete = "ageVerificationComplete",
  AgeVerificationNotCompleted = "ageVerificationNotCompleted",
  SFWPopup = "sfwPopup",
  LiteDelayedAVPopup = "liteDelayedAVPopup",
  LiteOnlyVerification = "liteOnlyVerification",
}

export const popups = {
  [PopupsEnum.Preferences]: PreferencesPopup,
  [PopupsEnum.ChangedEmail]: ChangedEmailPopup,
  [PopupsEnum.AddNiche]: AddToNichePopup,
  [PopupsEnum.Report]: ReportPopup,
  [PopupsEnum.AddCollection]: AddToCollectionPopup,
  [PopupsEnum.CreateCollection]: CreateNewCollectionPopup,
  [PopupsEnum.EditNiche]: EditNichePopup,
  [PopupsEnum.EditGifNiches]: EditNichesDialog,
  [PopupsEnum.EditGifPreferences]: GifPreferencePopup,
  [PopupsEnum.ShareGif]: ShareGifMenu,
  [PopupsEnum.MoreMenu]: MoreMenu,
  [PopupsEnum.EditGif]: EditGifPopup,
  [PopupsEnum.NicheMoreMenu]: NicheMoreMenu,
  [PopupsEnum.AddToNicheSuccess]: AddToNicheSuccessPopup,
  [PopupsEnum.AddDescriptionPopup]: AddDescriptionPopup,
  [PopupsEnum.AddToNicheConfirm]: AddToNicheConfirm,
  [PopupsEnum.Verification]: () => null,
  [PopupsEnum.GifNiches]: GifNichesPopup,
  [PopupsEnum.ProfileOptions]: ProfileOptions,
  [PopupsEnum.DeleteAccount]: DeleteAccount,
  [PopupsEnum.CreateNiche]: CreateNichePopup,
  [PopupsEnum.CaptchaPopup]: CaptchaPopup,
  [PopupsEnum.AgeDisclaimer]: AgeDisclaimerPopup,
  [PopupsEnum.AgeVerificationPrompt]: AgeVerificationPromptPopup,
  [PopupsEnum.AgeVerificationConnecting]: AgeVerificationConnectingPopup,
  [PopupsEnum.AgeVerificationComplete]: AgeVerificationCompletePopup,
  [PopupsEnum.AgeVerificationNotCompleted]: AgeVerificationNotCompletedPopup,
  [PopupsEnum.SFWPopup]: SFWPopup,
  [PopupsEnum.LiteDelayedAVPopup]: LiteDelayedAVPopup,
  [PopupsEnum.LiteOnlyVerification]: LiteOnlyVerificationPopup,
};
